import React, { Component } from 'react'

interface IProps {
  CName: string
}

interface IState {
  hasError: boolean
  info: string
}

class ErrorBoundary extends Component<IProps, IState> {
  state = {
    hasError: false,
    info: '',
  }
  componentDidCatch(error: any) {
    this.setState({ hasError: true, info: `${error.message}` })
  }

  render() {
    const { children } = this.props
    const { hasError, info } = this.state
    // 报错 且 非正式环境 显示楼层的错误提示
    if (hasError && (window as any).editorFlag !== 'detail') {
      return (
        <div>
          <span role="img">警告 ⚠</span>
          <div>{info}</div>
        </div>
      )
    }
    if (hasError) {
      return null
    }
    return children
  }
}

export default ErrorBoundary
